module.exports = __webpack_public_path__ + "static/media/pulsoximeter_green.40dce621.svg";